import api from "./api";

// Country service (CRUD)
// GET    /country
// GET    /country/:id
// POST   /country
// PATCH  /country/:id
// DELETE /country/:id

export async function getCountries() {
  const res = await api.get("/country");
  return Array.isArray(res) ? res : [];
}

export async function getCountryById(countryId) {
  if (countryId === undefined || countryId === null || countryId === "") {
    throw new Error("countryId is required");
  }
  const idNum = Number(countryId);
  if (!Number.isInteger(idNum)) throw new Error("countryId must be an integer");
  return api.get(`/country/${idNum}`);
}

export async function createCountry(payload) {
  return api.post("/country", payload || {});
}

export async function patchCountry(countryId, payload) {
  const idNum = Number(countryId);
  if (!Number.isInteger(idNum)) throw new Error("countryId must be an integer");
  const body = { ...(payload || {}) };
  delete body.countryId;
  delete body.id;
  return api.patch(`/country/${idNum}`, body);
}

export async function deleteCountry(countryId) {
  const idNum = Number(countryId);
  if (!Number.isInteger(idNum)) throw new Error("countryId must be an integer");
  return api.delete(`/country/${idNum}`);
}
